import React from 'react';
import ReactECharts from 'echarts-for-react';
import {
    useEChartsRef,
    useEChartsOption,
    useChartData,
} from '../../context';
import './chartRenderer.css';

function ChartRenderer() {
    const { echartsRef, setChartReady } = useEChartsRef();
    const echartsOption = useEChartsOption();
    const { hasChartData } = useChartData();

    if (!hasChartData) {
        return (
            <div className="chart-renderer__empty">
                No Chart Data
            </div>
        );
    }

    return (
        <ReactECharts
            ref={echartsRef}
            option={echartsOption}
            opts={{ devicePixelRatio: 2 }}
            style={{ height: '450px', width: '100%' }}
            onChartReady={() => setChartReady(true)}
            notMerge={true}
            lazyUpdate={false}
        />
    );
}

export default React.memo(ChartRenderer);
